import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

const UnsubscribePage = () => {
  const { t } = useTranslation();

  const [unsubscribed, setUnsubscribed] = useState<boolean>(false);


  const unsubscribe = async () => {
    try {
        const response = await fetch("/api/user/unsubscribe", {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response.ok) {
            setUnsubscribed(true);
        }
        
      } catch (err) {
        console.error("Error creating letter:", err);
      }
  };

  return (
    <div style={{padding: '20px'}}>
        <p>{t("unsubscribe.text")}</p>
        <br />
        <Button className="confirm-button" style={{width: '200px'}} onClick={unsubscribe}>
            {t("unsubscribe.button")}
        </Button>
        <br />
        {unsubscribed && <p>{t("unsubscribe.confirmMessage")}</p>}
    </div>
    
  );
};

export default UnsubscribePage;
